import { ParameterType } from '../enums';
import { ParsedFilter } from '../models/generalizations/ParsedFilter';

const WHERE_FILTERS = [
	ParameterType.KEYWORD_WHERE,
	ParameterType.COUNTRY,
	ParameterType.CONTINENT,
	ParameterType.ORGANISATIONS
] as const;
const WHAT_FILTERS = [ParameterType.KEYWORD_WHAT, ParameterType.DISCIPLINES] as const;

type WhereFilter = (typeof WHERE_FILTERS)[number];
type WhatFilter = (typeof WHAT_FILTERS)[number];

export class AutocompleteSelection {
	public selectedFilter: ParameterType;
	public value: string;
	public ommitedFilters: readonly ParameterType[];

	public forWhat(selectedFilter: WhatFilter, value: string): AutocompleteSelection {
		this.selectedFilter = selectedFilter;
		this.value = value;
		this.ommitedFilters = WHAT_FILTERS.filter((filter) => filter !== selectedFilter);
		return this;
	}

	public forWhere(selectedFilter: WhereFilter, value: string): AutocompleteSelection {
		this.selectedFilter = selectedFilter;
		this.value = value;
		this.ommitedFilters = WHERE_FILTERS.filter((filter) => filter !== selectedFilter);
		return this;
	}

	public process(): ParsedFilter[] {
		const filters: ParsedFilter[] = [];

		filters.push(new ParsedFilter(this.selectedFilter, [this.value]));

		const ommitedFilters = this.ommitedFilters.map((filter) => {
			return new ParsedFilter(filter, []);
		});
		filters.push(...ommitedFilters);

		return filters;
	}
}
